import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '@zag/ui';
import { TranslateService } from '@ngx-translate/core';

/**
 * HTTP interceptor that handles error responses, particularly 403 Forbidden errors.
 * Shows a toast notification for 403 errors while still propagating the error
 * for component-level handling.
 *
 * @example
 * ```typescript
 * // In app.config.ts
 * provideHttpClient(withInterceptors([httpErrorInterceptor]))
 * ```
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const translateService = inject(TranslateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const message = translateService.instant('access.error.forbidden');
        toastService.error(message);
      }

      return throwError(() => error);
    })
  );
};
